import React from "react";

/**
 * Logo that adapts to the surrounding text color via CSS mask.
 * - Place it inside a dark section with `text-white` → renders white
 * - Place it inside a light section with `text-[#333E48]` → renders dark
 *
 * Use the `className` to control width/height + color.
 */
export default function Logo({ className = "h-7 w-auto", style }) {
  return (
    <span
      role="img"
      aria-label="Ajoyo"
      className={`inline-block ${className}`}
      style={{
        backgroundColor: "currentColor",
        WebkitMaskImage: "url(/ajoyo-logo.png)",
        maskImage: "url(/ajoyo-logo.png)",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        // Default aspect ratio (logo is square)
        aspectRatio: "1 / 1",
        ...style,
      }}
    />
  );
}
